import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenVaccinationsIndicatorC6Data } from "@/services/esus/indicator/esf/c6/getDetailedCitizensVaccinationsIndicatorC6";

import { IndicatorEsfC6CitizensVaccinationsHistoryInfo } from "./IndicatorEsfC6CitizensVaccinationsHistoryInfo";
import { VaccinationCard } from "@/components/VaccinationCard";

type IndicatorEsfC6CitizensVaccinationsHistoryProps = {
	citizenWithVaccinations: DetailedCitizenVaccinationsIndicatorC6Data;
};

export function IndicatorEsfC6CitizensVaccinationsHistory({
	citizenWithVaccinations,
}: Readonly<IndicatorEsfC6CitizensVaccinationsHistoryProps>) {
	const indicatorEsfC6CitizensVaccinationsHistoryInfo = {
		fullName: citizenWithVaccinations.fullName ?? "N/A",
		birthdate: citizenWithVaccinations.birthdate
			? dayjs(citizenWithVaccinations.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithVaccinations.cpf
			? formatIdentifier(citizenWithVaccinations.cpf)
			: citizenWithVaccinations.cns ?? "",
		motherName: citizenWithVaccinations.motherName ?? "",
		phone: citizenWithVaccinations.phone ? phoneFormat(citizenWithVaccinations.phone) : "",
		address:
			addressConcat(
				citizenWithVaccinations.street,
				citizenWithVaccinations.houseNumber,
				citizenWithVaccinations.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC6CitizensVaccinationsHistoryInfo
				{...indicatorEsfC6CitizensVaccinationsHistoryInfo}
			/>
			<VaccinationCard
				vaccinations={(citizenWithVaccinations.vaccines ?? []).map((vaccine) => {
					return {
						id: vaccine.id,
						dateofVaccine: dayjs(vaccine.dateofVaccine).format("DD/MM/YYYY"),
						immunobiological: vaccine.immunobiological,
						immunobiologicalDosage: vaccine.immunobiologicalDosage,
						professional: vaccine.professional,
						healthTeam: vaccine.healthTeam,
						healthUnit: vaccine.healthUnit,
						status: "vaccinated",
						healthTeamId: vaccine.healthTeamId,
						healthUnitId: vaccine.healthUnitId,
					};
				})}
			/>
		</>
	);
}
